import React from 'react';
import NwsHeatIndexGuidance
  from '@avtechsoftware/react-component-library/src/components/guidance/NwsHeatIndexGuidance/NwsHeatIndexGuidance';
import PropTypes from 'prop-types';
import { masterDeviceListPropType } from '@avtechsoftware/react-component-library/src/types/AvtechPropTypes';
import emptyFunction from '@avtechsoftware/ra-javascript-utilities/src/utilities/EmptyFunction';
import filterSampleListOnMatchers from '@avtechsoftware/ra-javascript-utilities/src/utilities/samples/SampleUtility';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  selectSessionInformation,
  sessionInformationPropType,
} from '../../../../redux/slices/sessionSlice';
import { RaaRoles, sessionUserHasRolePrivileges } from '../../../../utility/SecurityRules';
import { sessionHash } from '../../../../utility/remoteServiceUtil';
import envConfig from '../../../../envConfig';
import {
  channelKeyListToSensorList,
  fetchDeviceListData, selectByUuidOrMacAddress,
  selectRoomAlertDeviceList,
  selectSensorMap,
} from '../../../../redux/slices/deviceList/deviceListSlice';
import {
  selectAllThresholdRanges,
  selectThresholdRangeById,
} from '../../../../redux/slices/thresholdRangeSlice/thresholdRangeSlice';

class NwsHeatIndexGuidanceConnected extends React.Component {
  constructor(props) {
    super(props);
    this.redirectToExploreSensorData = this.redirectToExploreSensorData.bind(this);
  }

  redirectToExploreSensorData() {
    const { history } = this.props;
    history.push('/s/sensor-data/explore');
  }

  /* istanbul ignore next */
  render() {
    const {
      masterDeviceListContext,
      sessionInformation,
      thresholdRangeContext,
      latestSamples,
      sensorMap,
    } = this.props;
    return (
      <NwsHeatIndexGuidance
        getSensorMap={() => sensorMap}
        latestHeatIndexReadings={filterSampleListOnMatchers(latestSamples, ['*_*_*_1_*_*'])}
        authToken={sessionHash}
        masterDeviceList={masterDeviceListContext}
        thresholdRangeContext={thresholdRangeContext}
        temperatureScale={sessionInformation.temperatureScale}
        reportDataUrlBase={`${envConfig.apiUrl}/api/v1/device-data/device/samples/find-by-channel-keys`}
        exploreSensorDataFunc={this.redirectToExploreSensorData}
        enableAlternateSensorView={false}
        updateHeatIndexPreference={emptyFunction}
        applicationName="Room Alert Account"
        userHasAdminPrivileges={
          sessionUserHasRolePrivileges(sessionInformation.activeSubscription, [RaaRoles.ADMIN])
        }
      />
    );
  }
}

NwsHeatIndexGuidanceConnected.propTypes = {
  masterDeviceListContext: masterDeviceListPropType.isRequired,
  thresholdRangeContext: PropTypes.shape({
    findAll: PropTypes.func.isRequired,
    findById: PropTypes.func.isRequired,
  }).isRequired,
  history: PropTypes.shape({ push: PropTypes.func }).isRequired,
  latestSamples: PropTypes.objectOf(PropTypes.shape(
    { t: PropTypes.number, v: PropTypes.string },
  )).isRequired,
  sessionInformation: sessionInformationPropType.isRequired,
  sensorMap: PropTypes.arrayOf(PropTypes.string).isRequired,
};
/* istanbul ignore next */
const mapStateToProps = (state) => ({
  sessionInformation: selectSessionInformation(state),
  thresholdRangeContext: {
    findAll: () => selectAllThresholdRanges(state),
    findById: (id) => selectThresholdRangeById(state, id),
  },
  sensorMap: selectSensorMap(state),
  masterDeviceListContext: {
    deviceList: selectRoomAlertDeviceList(state),
    findAll: () => selectRoomAlertDeviceList(state),
    refresh: () => fetchDeviceListData(),
    channelKeyListToSensorList: (channelKeyList) => channelKeyListToSensorList(
      state, channelKeyList,
    ),
    findByUUID: (id) => selectByUuidOrMacAddress(state, id),
    getSensorMap: () => selectSensorMap(state),
    getFullDeviceList: () => selectRoomAlertDeviceList(state),
  },
});

export { NwsHeatIndexGuidanceConnected };
export default withRouter(connect(mapStateToProps)(NwsHeatIndexGuidanceConnected));
